(function (global) {
  'use strict';

  var OV_LANG = (global.document && global.document.documentElement && global.document.documentElement.lang) || 'nl';

  // Locale table for strings this file writes into the DOM at runtime.
  // Keyed on document.documentElement.lang; anything not 'fr' falls back to
  // the original nl copy, so Dutch behaviour stays bit-identical.
  var OV_STRINGS = {
    galleryCounterSuffix: { nl: 'beelden', fr: 'images' },
    bonusUnit: { nl: 'stuks', fr: 'bandes' },
    bonusSuffix: { nl: 'GRATIS', fr: 'GRATUITES' },
    purchaseLabel: { nl: 'In winkelwagen', fr: 'Ajouter au panier' },
    bundleUnit: { nl: 'stuks', fr: 'bandes' },
    colourLegendVerb: { nl: 'Kies', fr: 'Choisissez' },
    colourSingular: { nl: 'kleur', fr: 'couleur' },
    colourPlural: { nl: 'kleuren', fr: 'couleurs' }
  };

  function ovText(key) {
    var entry = OV_STRINGS[key];
    if (!entry) return '';
    return entry[OV_LANG] || entry.nl;
  }

  var offers = Object.freeze({
    10: Object.freeze({ colourCount: 1, priceCents: 2995, bonusCount: 0 }),
    20: Object.freeze({ colourCount: 3, priceCents: 4995, bonusCount: 10 }),
    40: Object.freeze({ colourCount: 5, priceCents: 7995, bonusCount: 20 })
  });

  function gallerySwipeChange(deltaX, deltaY) {
    if (!Number.isFinite(deltaX) || !Number.isFinite(deltaY)) return 0;
    if (Math.abs(deltaX) <= 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return 0;
    return deltaX < 0 ? 1 : -1;
  }

  function offerConfig(size) {
    var offer = offers[Number(size)] || offers[20];
    return Object.freeze({ colourCount: offer.colourCount, priceCents: offer.priceCents, bonusCount: offer.bonusCount });
  }

  // Reads a tier's economics off the element Liquid rendered, so a product whose
  // bundles are not 10/20/40 still shows its own price and bonus.
  //
  // The `offers` table above only ever described the hallux tape. Falling back to
  // it for an unrecognised size meant any other product silently rendered
  // "€49,95 / + 10 stuks GRATIS" — a wrong price, not just a wrong label. So an
  // unknown tier with no data attributes now returns null, and the caller leaves
  // whatever Liquid rendered untouched rather than overwriting it with a guess.
  function readOffer(choice) {
    if (!choice) return null;
    var data = choice.dataset || {};
    var priceCents = Number(data.priceCents);
    var bonusCount = Number(data.bonusCount);
    var colourCount = Number(data.colourCount);
    var declared = Number.isFinite(priceCents)
      && Number.isFinite(bonusCount)
      && Number.isFinite(colourCount)
      && data.priceCents !== undefined
      && data.bonusCount !== undefined
      && data.colourCount !== undefined;

    if (declared) {
      return Object.freeze({
        colourCount: colourCount,
        priceCents: priceCents,
        bonusCount: bonusCount,
        bonusUnit: data.bonusUnit || ovText('bonusUnit')
      });
    }

    var known = offers[Number(choice.value)];
    if (!known) return null;
    return Object.freeze({
      colourCount: known.colourCount,
      priceCents: known.priceCents,
      bonusCount: known.bonusCount,
      bonusUnit: ovText('bonusUnit')
    });
  }

  function formatPrice(priceCents) {
    var euros = Math.floor(priceCents / 100);
    var cents = String(priceCents % 100).padStart(2, '0');
    return '€' + euros + ',' + cents;
  }

  function bindGallery(root) {
    var track = root.querySelector('[data-v2t-gallery-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-v2t-gallery-slide]'));
    var controls = Array.prototype.slice.call(root.querySelectorAll('[data-v2t-gallery-control]'));
    var counter = root.querySelector('[data-v2t-gallery-counter]');
    if (!track || !slides.length || slides.length !== controls.length) return;

    var currentIndex = Math.max(0, controls.findIndex(function (control) {
      return control.getAttribute('aria-current') === 'true';
    }));

    function selectSlide(nextIndex) {
      currentIndex = Math.max(0, Math.min(slides.length - 1, nextIndex));
      slides.forEach(function (slide, index) {
        slide.hidden = index !== currentIndex;
      });
      controls.forEach(function (control, index) {
        if (index === currentIndex) control.setAttribute('aria-current', 'true');
        else control.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = (currentIndex + 1) + ' / ' + slides.length + ' ' + ovText('galleryCounterSuffix');
    }

    controls.forEach(function (control, index) {
      control.addEventListener('click', function () { selectSlide(index); });
    });

    var pointerStart = null;
    track.addEventListener('pointerdown', function (event) {
      if (event.isPrimary === false || (event.pointerType === 'mouse' && event.button !== 0)) return;
      if (!Number.isFinite(event.clientX) || !Number.isFinite(event.clientY)) return;
      pointerStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
    });
    track.addEventListener('pointerup', function (event) {
      if (!pointerStart || event.pointerId !== pointerStart.id) return;
      var change = gallerySwipeChange(event.clientX - pointerStart.x, event.clientY - pointerStart.y);
      pointerStart = null;
      if (change) selectSlide(currentIndex + change);
    });
    track.addEventListener('pointercancel', function () { pointerStart = null; });

    selectSlide(currentIndex);
  }

  function bindOffer(root) {
    var choices = Array.prototype.slice.call(root.querySelectorAll('[data-v2t-offer-choice]'));
    var variant = root.querySelector('[data-v2t-variant-id]');
    var prices = Array.prototype.slice.call(root.querySelectorAll('[data-v2t-price]'));
    var bonuses = Array.prototype.slice.call(root.querySelectorAll('[data-v2t-bonus]'));
    var bonusProperty = root.querySelector('[data-v2t-bonus-property]');
    var stickyBundle = root.querySelector('[data-v2t-sticky-bundle]');
    var purchase = root.querySelector('[data-v2t-purchase]');
    var purchaseLabel = root.querySelector('[data-v2t-purchase-label]');
    var purchasePrice = root.querySelector('[data-v2t-purchase-price]');
    var stickySubmit = root.querySelector('[data-v2t-sticky-submit]');
    var colourLegend = root.querySelector('[data-v2t-colour-legend]')
      || root.querySelector('[data-v2t-colour-fields] legend');
    var colourFields = Array.prototype.slice.call(root.querySelectorAll('[data-v2t-colour-field]'));
    if (!choices.length || !variant) return;

    function selectOffer(choice) {
      if (!choice || choice.disabled) return;
      var size = Number(choice.value);
      var config = readOffer(choice);

      choices.forEach(function (item) { item.checked = item === choice; });
      variant.value = choice.dataset.variantId || variant.value;

      // No declared economics and no known tier: the variant id still switches,
      // but Liquid's own price and bonus stay on screen. Better a stale-looking
      // page than a confidently wrong price.
      if (!config) return;

      var price = formatPrice(config.priceCents);
      var bonusText = config.bonusCount > 0
        ? '+ ' + config.bonusCount + ' ' + config.bonusUnit + ' ' + ovText('bonusSuffix')
        : '';

      prices.forEach(function (output) { output.textContent = price; });
      bonuses.forEach(function (output) {
        output.textContent = bonusText;
        output.hidden = !bonusText;
      });
      if (purchase) {
        purchase.disabled = false;
        purchase.removeAttribute('aria-disabled');
      }
      if (purchaseLabel) purchaseLabel.textContent = ovText('purchaseLabel');
      if (purchasePrice) {
        purchasePrice.textContent = price;
        purchasePrice.hidden = false;
      }
      if (stickySubmit) {
        stickySubmit.disabled = false;
        stickySubmit.removeAttribute('aria-disabled');
      }
      if (bonusProperty) {
        // Shopify drops empty line-item properties, so the 10-pack carries none.
        bonusProperty.value = bonusText;
        bonusProperty.disabled = !bonusText;
      }
      if (stickyBundle) stickyBundle.textContent = choice.dataset.bundleLabel || (size + ' ' + ovText('bundleUnit'));
      if (colourLegend) colourLegend.textContent = ovText('colourLegendVerb') + ' ' + config.colourCount + ' ' + (config.colourCount === 1 ? ovText('colourSingular') : ovText('colourPlural'));

      colourFields.forEach(function (field, index) {
        var inputs = Array.prototype.slice.call(field.querySelectorAll('input[type="radio"]'));
        var active = index < config.colourCount;
        field.hidden = !active;
        inputs.forEach(function (input) {
          input.disabled = !active;
          input.required = active;
        });
      });
    }

    choices.forEach(function (choice) {
      choice.addEventListener('change', function () { selectOffer(choice); });
    });
    selectOffer(choices.find(function (choice) { return choice.checked; })
      || choices.find(function (choice) { return !choice.disabled; }));
  }

  function bindReviews(root) {
    var stack = root.querySelector('[data-v2t-review-track]');
    if (!stack) return;
    var controls = Array.prototype.slice.call(root.querySelectorAll('[data-v2t-review-control]'));
    var cards = Array.prototype.slice.call(stack.querySelectorAll('.ov-v2t-review'));
    if (!controls.length || !cards.length) return;

    controls.forEach(function (control) {
      control.addEventListener('click', function () {
        var direction = Number(control.getAttribute('data-v2t-review-control')) || 1;
        var current = cards.reduce(function (nearest, card, index) {
          return Math.abs(card.offsetLeft - stack.scrollLeft) < Math.abs(cards[nearest].offsetLeft - stack.scrollLeft)
            ? index : nearest;
        }, 0);
        var target = cards[Math.max(0, Math.min(cards.length - 1, current + direction))];
        var reducedMotion = global.matchMedia
          && global.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (target) stack.scrollTo({ left: target.offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
      });
    });
  }

  function bindSticky(root) {
    var sticky = root.querySelector('[data-v2t-sticky]')
      || root.querySelector('[data-v2t-slot="sticky-cta"]');
    var buyAnchor = root.querySelector('[data-v2t-buy-anchor]');
    if (!sticky || !buyAnchor) return;

    if (typeof global.IntersectionObserver !== 'function') {
      sticky.hidden = false;
      sticky.setAttribute('data-v2t-sticky-fallback', '');
      if (sticky.classList) sticky.classList.add('ov-v2t-sticky--flow');
      return;
    }

    sticky.hidden = true;
    sticky.removeAttribute('data-v2t-sticky-fallback');
    if (sticky.classList) sticky.classList.remove('ov-v2t-sticky--flow');
    // The bar stays available from the moment the buy box scrolls away until the
    // end of the page. It previously hid as soon as the newsletter/footer entered
    // view, which removed the CTA exactly when a reader had finished the page and
    // was deciding. Overlap is handled with footer padding, not by hiding it.
    var buyPassed = false;
    function syncSticky() { sticky.hidden = !buyPassed; }

    var observer = new global.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === buyAnchor) {
          buyPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        }
      });
      syncSticky();
    }, { threshold: 0, rootMargin: '0px 0px 96px 0px' });
    observer.observe(buyAnchor);
  }

  function init(root) {
    if (!root) return;
    if (root.dataset.v2tInitialized === 'true') return root;
    root.dataset.v2tInitialized = 'true';
    bindGallery(root);
    bindOffer(root);
    bindReviews(root);
    bindSticky(root);
    return root;
  }

  global.OVV2Trust = {
    init: init,
    gallerySwipeChange: gallerySwipeChange,
    offerConfig: offerConfig,
    readOffer: readOffer
  };

  function initializePage() {
    init(global.document && global.document.querySelector('[data-v2-trust]'));
  }

  if (global.document) {
    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', initializePage, { once: true });
    } else {
      initializePage();
    }
  }
})(globalThis);
